export default __webpack_public_path__ + "static/media/gallery18.a7983909.webp";